import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "The Fleet", href: "#fleet" },
  { label: "Training Hub", href: "#training" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50"
      data-testid="site-navbar"
    >
      <div className={`transition-all duration-500 ${scrolled ? "glass-nav-light" : "bg-white/90 backdrop-blur-sm"}`}>
        <nav className="mx-auto flex max-w-[1400px] items-center justify-end px-6 py-4 md:justify-center md:px-10">
          <div className="hidden items-center gap-9 md:flex">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="overline text-[0.68rem] text-[#3D5068] transition-colors duration-300 hover:text-[#0C2340]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              data-testid="nav-cta-button"
              className="btn-ink font-mono-2 rounded-sm px-5 py-2.5 text-[0.7rem] font-semibold uppercase tracking-[0.18em]"
            >
              Request Consult
            </a>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="flex flex-col gap-1.5 md:hidden"
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
          >
            <span className={`h-px w-7 bg-[#0C2340] transition-all ${open ? "translate-y-2 rotate-45" : ""}`} />
            <span className={`h-px w-7 bg-[#0C2340] transition-all ${open ? "opacity-0" : ""}`} />
            <span className={`h-px w-7 bg-[#0C2340] transition-all ${open ? "-translate-y-2 -rotate-45" : ""}`} />
          </button>
        </nav>
      </div>

      {open && (
        <div className="glass-nav-light md:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col px-6 py-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="overline overline-dark border-b border-[#0C2340]/10 py-3 hover:text-[#0C2340]"
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </motion.header>
  );
};
